import {MenuItem, TextField, Button, Rating, Stack, Alert, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, CircularProgress} from '@mui/material';
import Layout from "../../../components/Frames/Layout"
import { useQuery} from 'react-query';
import Reviews from '../../../services/API/Reviews'
import { useState } from 'react';
import Tip from '../../Tools/Tip';
import Answered from './Answered';
import Comment from './Comment';
import CourseSelect from '../../Inputs/CourseSelect';
import Kpi from '../../Tools/Kpi';
import Flex from '../../Tools/Flex';
import CategorySelect from '../../Inputs/CategorySelect';
import API from '../../../services/API/API';
import { LoadingButton } from '@mui/lab';

export default function List(){

    const {data, isSuccess, isError, isLoading} = useQuery('reviews', () => Reviews.getAll().then(r => r.data));

    const [displayComment, setDisplayComment] = useState(false)
    const step = 10;
    const [limit, setLimit] = useState(step)
    const [downloading, setDownloading] = useState(false)

    const [search, setSearch] = useState({
        course: new URLSearchParams(window.location.search).get('course'), 
        min: 1, 
        max: 5,
        category: 'all'
    })

    const toggleComment = id => {
        return setDisplayComment(
            !displayComment ? id : (displayComment === id ? false : id)
        );
    }

    const match = i => (!search.course || search.course === i.course?.id)
        && i.rating >= search.min && i.rating <= search.max
        && ['all', i.category?.id].includes(search.category)

    const list = !isSuccess ? [] : data
        .filter(i => match(i))
        .sort((a,b) => a.createdAt < b.createdAt ? 1 : -1)

    const count = list.length

    const avg = count === 0 ? 0 : 
        (list.reduce((a,b) => a + b.rating, 0) / count)


    const handleDownload = () => {

        API.downloadFile(API.url('/csv/reviews/data.csv'), 'avis.csv')
            .then(r => setDownloading(false)).catch(e => setDownloading(false))

        return setDownloading(true);
    }

    return <Layout title="Avis des apprenants" tab="reviews" menu="marketing">

        <Flex sx={{mb: 2}}>
            
            <Kpi 
                title={count.toLocaleString()} 
                caption="Nombre d'avis" 
                icon='people'
                sx={{mr: 1, mb: 1}}
            />

            <Kpi 
                title={avg.toFixed(1)} 
                caption="Note moyenne" 
                icon='stars'
                sx={{mr: 1, mb: 1}}
            />
        
        </Flex>

        <Stack direction='row' sx={{flexWrap: 'wrap', mb: 1}}>

            <CourseSelect
                value={search.course || ''}
                onChange={id => setSearch({...search, course: id})}
                required={true}
                sx={{mr: 1, mb: 1, width: 300}}
            />
            
            <TextField
                label='Note min'
                select
                size='small'
                value={search.min}
                onChange={e => setSearch({...search, min: parseInt(e.target.value)})}
                sx={{mr: 1, mb: 1, width: 100}}
            >
                {[1,2,3,4,5].map(k => 
                    <MenuItem key={k} value={k}>{k}/5</MenuItem>    
                )}
            </TextField>

            <TextField
                label='Note max'
                select
                size='small'
                value={search.max}
                onChange={e => setSearch({...search, max: parseInt(e.target.value)})}
                sx={{mr: 1, mb: 1, width: 100}}
            >
                {[1,2,3,4,5].map(k => 
                    <MenuItem key={k} value={k}>{k}/5</MenuItem>    
                )}
            </TextField>

            <CategorySelect
                value={search.category}
                onChange={val => setSearch({...search, category: val})}
                sx={{mr: 1, mb: 1}}
            />

            <LoadingButton 
                sx={{mr: 1, mb: 1}}
                onClick={handleDownload}
                loading={downloading}
            >
                Télécharger tout
            </LoadingButton>

        </Stack>

        {isError && <Alert severity="error">Vous êtes déconnecté. Les données n'ont pas pu être récupérées.</Alert>}

        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell><b>Formation</b></TableCell>
                        <TableCell><b>Apprenant</b></TableCell>
                        <TableCell><b>Filière</b></TableCell>
                        <TableCell><b>Note</b></TableCell>
                        <TableCell><b>Commentaire</b></TableCell>
                        <TableCell><b>Date</b></TableCell>
                        <TableCell><b>Répondre</b></TableCell>
                        <TableCell><b>Traité</b></TableCell>
                    </TableRow>
                </TableHead>

                {isSuccess && <TableBody>

                    {list.slice(0, limit).map(i => 
                        <TableRow key={i.id}>
                            <TableCell>{i.course?.title}</TableCell>
                            <TableCell>{i.user?.name}</TableCell>
                            <TableCell>{i.category?.title}</TableCell>
                            <TableCell>
                                <Rating value={i.rating} readOnly/>
                            </TableCell>
                            <TableCell>
                                <Comment 
                                    text={i.comment || ''} 
                                    display={i.id === displayComment}
                                    onClick={() => toggleComment(i.id)}
                                />
                            </TableCell>
                            <TableCell>{new Date(i.createdAt).toLocaleDateString()}</TableCell>
                            <TableCell align='center'>
                                <a href={'mailto:' + i.user?.email}>
                                    <Tip type='mail' />
                                </a>
                            </TableCell>
                            <TableCell align='center'>
                                <Answered review={i} />
                            </TableCell>
                        </TableRow>    
                    )}

                </TableBody>}
            </Table>
        </TableContainer>

        {isSuccess && list.length > limit &&
            <Button onClick={() => setLimit(limit + step)}>Afficher la suite</Button>
        }

       {isLoading && <Stack direction='row' justifyContent='center' sx={{mt: 3}}>
            <CircularProgress size={24} />
        </Stack>}

    </Layout>
}




